
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Anti-Fraud Protection',
    subtitle: 'Referral program rules and anti-fraud protection',
    description:
      'Our referral program lets you receive a reward of {{reward}} coins when an invited user makes their first deposit or withdrawal. However, to maintain fair conditions and protect against abuse, there is a system for checking the quality of attracted users.',
    howToAvoidTitle: 'How to Avoid Reward Blocking',
    howToAvoidItem1: 'Invite only real users interested in the application.',
    howToAvoidItem2: 'Do not use scripts, mass mailings and other automatic cheating tools.',
    howToAvoidItem3:
      'Do not mislead people when inviting - honestly explain what this service is and why to follow your link.',
    howToAvoidInfo:
      'The system tracks suspicious activity automatically, so it is important to follow these rules so that the program remains profitable and fair for all participants.',
  },
  ru: {
    title: 'Защита от накруток',
    subtitle: 'Правила реферальной программы и защита от накруток',
    description:
      'Наша реферальная программа позволяет получать вознаграждение в размере {{reward}} монет, когда приглашённый друг делает первый депозит или выводит первый предмет. Однако для поддержания честных условий и защиты от злоупотреблений действует система проверки качества привлечённых пользователей.',
    howToAvoidTitle: 'Как избежать блокировки вознаграждений',
    howToAvoidItem1: 'Приглашай только реальных пользователей, заинтересованных в приложении.',
    howToAvoidItem2: 'Не используй скрипты, массовые рассылки и другие инструменты автоматической накрутки.',
    howToAvoidItem3:
      'Не вводи в заблуждение людей при приглашении — честно объясняй, что это за сервис и зачем переходить по твоей ссылке.',
    howToAvoidInfo:
      'Система отслеживает подозрительную активность автоматически, поэтому важно соблюдать эти правила, чтобы программа оставалась выгодной и честной для всех участников.',
  },
  uz: {
    title: 'Soxtalashtirishdan himoya',
    subtitle: 'Referal dasturi qoidalari va soxtalashtirishdan himoya',
    description:
      'Bizning referal dasturimiz taklif qilingan doʻst birinchi depozit yoki birinchi chiqarishni amalga oshirganda {{reward}} tanga mukofot olish imkonini beradi. Ammo adolatli sharoitlarni saqlash va suiisteʼmollikdan himoya qilish uchun jalb qilingan foydalanuvchilar sifatini tekshirish tizimi mavjud.',
    howToAvoidTitle: 'Mukofotlar blokirovkasidan qanday qochish mumkin',
    howToAvoidItem1: 'Faqat ilovaga qiziqayotgan haqiqiy foydalanuvchilarni taklif qiling.',
    howToAvoidItem2:
      'Skriptlar, ommaviy pochta xabarlari va boshqa avtomatik soxtalashtirish vositalaridan foydalanmang.',
    howToAvoidItem3:
      'Taklif qilayotganda odamlarni chalgʻitmang - bu qanday xizmat ekanligini va havolangiz boʻyicha nima uchun oʻtish kerakligini halol tushuntiring.',
    howToAvoidInfo:
      'Tizim shubhali faoliyatni avtomatik ravishda kuzatadi, shuning uchun dastur barcha ishtirokchilar uchun foydali va adolatli boʻlib qolishi uchun ushbu qoidalarga rioya qilish muhimdir.',
  },
  fa: {
    title: 'محافظت ضد تقلب',
    subtitle: 'قوانین برنامه دعوت و محافظت ضد تقلب',
    description:
      'برنامه دعوت ما وقتی کاربر دعوت‌شده اولین شارژ یا برداشتش را انجام دهد، {{reward}} سکه به تو می‌دهد. برای اینکه شرایط برای همه منصفانه بماند و کسی سوءاستفاده نکند، کیفیت کاربران جذب‌شده بررسی می‌شود.',
    howToAvoidTitle: 'چطور جایزه‌ات مسدود نشود',
    howToAvoidItem1: 'فقط کاربران واقعی که به برنامه علاقه دارند را دعوت کن.',
    howToAvoidItem2: 'از اسکریپت، ارسال انبوه و ابزارهای خودکار تقلب استفاده نکن.',
    howToAvoidItem3:
      'موقع دعوت کسی را گمراه نکن — صادقانه بگو این سرویس چیست و چرا باید از لینک تو وارد شود.',
    howToAvoidInfo:
      'سیستم فعالیت مشکوک را خودکار دنبال می‌کند، پس رعایت این قوانین مهم است تا برنامه برای همه سودده و منصفانه بماند.',
  },
  pt: {
    title: 'Proteção contra fraude',
    subtitle: 'Regras do programa de indicação e proteção contra fraude',
    description:
      'Nosso programa de indicação dá uma recompensa de {{reward}} moedas quando um amigo convidado faz o primeiro depósito ou saca o primeiro item. Mas, para manter as condições justas e evitar abusos, existe um sistema que verifica a qualidade dos usuários trazidos.',
    howToAvoidTitle: 'Como evitar o bloqueio das recompensas',
    howToAvoidItem1: 'Convide só usuários reais, interessados no aplicativo.',
    howToAvoidItem2: 'Não use scripts, envios em massa e outras ferramentas de fraude automática.',
    howToAvoidItem3:
      'Não engane as pessoas ao convidar — explique com sinceridade o que é o serviço e por que entrar pelo seu link.',
    howToAvoidInfo:
      'O sistema rastreia atividade suspeita automaticamente, então é importante seguir essas regras para que o programa continue vantajoso e justo para todos.',
  },
  tr: {
    title: 'Hile koruması',
    subtitle: 'Davet programının kuralları ve hile koruması',
    description:
      'Davet programımız, davet ettiğin arkadaşın ilk yatırımını yaptığında ya da ilk eşyasını çektiğinde sana {{reward}} coin ödül verir. Ancak adil koşulları korumak ve kötüye kullanımı önlemek için getirilen kullanıcıların kalitesini kontrol eden bir sistem var.',
    howToAvoidTitle: 'Ödüllerin engellenmesinden nasıl kaçınırsın',
    howToAvoidItem1: 'Sadece uygulamayla gerçekten ilgilenen gerçek kullanıcıları davet et.',
    howToAvoidItem2: 'Script, toplu mesaj ve diğer otomatik hile araçlarını kullanma.',
    howToAvoidItem3:
      'Davet ederken insanları yanıltma — bu servisin ne olduğunu ve linkine neden girmeleri gerektiğini dürüstçe anlat.',
    howToAvoidInfo:
      'Sistem şüpheli aktiviteyi otomatik takip eder; bu yüzden programın herkes için kazançlı ve adil kalması adına bu kurallara uymak önemli.',
  },
  uk: {
    title: 'Захист від накруток',
    subtitle: 'Правила реферальної програми та захист від накруток',
    description:
      'Наша реферальна програма дає змогу отримувати винагороду в розмірі {{reward}} монет, коли запрошений друг робить перший депозит або виводить перший предмет. Однак для підтримання чесних умов і захисту від зловживань діє система перевірки якості залучених користувачів.',
    howToAvoidTitle: 'Як уникнути блокування винагород',
    howToAvoidItem1: 'Запрошуй лише реальних користувачів, які цікавляться застосунком.',
    howToAvoidItem2: 'Не використовуй скрипти, масові розсилки й інші інструменти автоматичної накрутки.',
    howToAvoidItem3:
      'Не вводь людей в оману під час запрошення — чесно пояснюй, що це за сервіс і навіщо переходити за твоїм посиланням.',
    howToAvoidInfo:
      'Система відстежує підозрілу активність автоматично, тому важливо дотримуватися цих правил, щоб програма залишалася вигідною й чесною для всіх учасників.',
  },
  de: {
    title: 'Schutz vor Betrug',
    subtitle: 'Regeln des Empfehlungsprogramms und Schutz vor Betrug',
    description:
      'Mit unserem Empfehlungsprogramm erhältst du {{reward}} Münzen als Belohnung, wenn ein eingeladener Freund seine erste Einzahlung macht oder sein erstes Item auszahlt. Damit die Bedingungen fair bleiben und Missbrauch verhindert wird, gibt es ein System, das die Qualität der geworbenen Nutzer prüft.',
    howToAvoidTitle: 'So vermeidest du eine Sperrung der Belohnungen',
    howToAvoidItem1: 'Lade nur echte Nutzer ein, die sich für die App interessieren.',
    howToAvoidItem2: 'Nutze keine Skripte, Massenversendungen oder andere automatische Manipulationstools.',
    howToAvoidItem3:
      'Führe Leute beim Einladen nicht in die Irre – erkläre ehrlich, was das für ein Dienst ist und warum man deinem Link folgen sollte.',
    howToAvoidInfo:
      'Das System erkennt verdächtige Aktivität automatisch. Halte dich deshalb an diese Regeln, damit das Programm für alle Teilnehmer vorteilhaft und fair bleibt.',
  },
  es: {
    title: 'Protección contra fraude',
    subtitle: 'Reglas del programa de referidos y protección contra fraude',
    description:
      'Nuestro programa de referidos te permite recibir una recompensa de {{reward}} monedas cuando un amigo invitado hace su primer depósito o retira su primer objeto. Para mantener condiciones justas y evitar abusos, existe un sistema que comprueba la calidad de los usuarios captados.',
    howToAvoidTitle: 'Cómo evitar el bloqueo de recompensas',
    howToAvoidItem1: 'Invita solo a usuarios reales interesados en la aplicación.',
    howToAvoidItem2: 'No uses scripts, envíos masivos ni otras herramientas de manipulación automática.',
    howToAvoidItem3:
      'No engañes a la gente al invitarla: explica con honestidad qué es este servicio y por qué entrar con tu enlace.',
    howToAvoidInfo:
      'El sistema detecta la actividad sospechosa automáticamente, así que es importante seguir estas reglas para que el programa siga siendo beneficioso y justo para todos los participantes.',
  },
  pl: {
    title: 'Ochrona przed oszustwami',
    subtitle: 'Zasady programu poleceń i ochrona przed oszustwami',
    description:
      'Nasz program poleceń pozwala otrzymać nagrodę w wysokości {{reward}} monet, gdy zaproszony znajomy zrobi pierwszą wpłatę lub wypłaci pierwszy przedmiot. Aby zachować uczciwe warunki i chronić przed nadużyciami, działa system sprawdzania jakości pozyskanych użytkowników.',
    howToAvoidTitle: 'Jak uniknąć blokady nagród',
    howToAvoidItem1: 'Zapraszaj tylko prawdziwych użytkowników, którzy interesują się aplikacją.',
    howToAvoidItem2: 'Nie używaj skryptów, masowych wysyłek ani innych narzędzi do automatycznego nabijania.',
    howToAvoidItem3:
      'Nie wprowadzaj ludzi w błąd przy zapraszaniu — uczciwie wyjaśnij, czym jest ten serwis i po co wchodzić z twojego linku.',
    howToAvoidInfo:
      'System automatycznie wykrywa podejrzaną aktywność, dlatego ważne jest przestrzeganie tych zasad, aby program pozostał korzystny i uczciwy dla wszystkich uczestników.',
  },
});
